import React, {PureComponent} from 'react';
import {Root} from './Clientlist.css';
import PageTitle from '../Layout/components/PageTitle';
import Client from '../AddClient/components/Client';
import {
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    InputBase,
    Dialog,
    Drawer,
    Tabs,
    Tab,
    TableFooter,
    TablePagination
} from '@material-ui/core';
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SideList from '../Clientlist/components/SideList'
import {BASE_URL} from '../../store/config';
import instance from '../../request/http'
import {roleStr, isRole, ROLES, defaultPageSize, ADD, EDIT, VIEW} from '../../common/common';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'
import ShareList from '../Components/ShareList';
import { withRouter } from 'react-router-dom';

const CLIENT = 11;
const INDIVIDUAL = "individual";
const CORPORATION = "corporation";
const AUDITED = "audited";

class Clientlist extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openShare: false,
            stateRight: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            totalUser: [],
            tabIndex: 0,
            client_id: 0,
            iClients: [],
            cClients: [],
            iClientsCopy: [],
            cClientsCopy: [],
            searchName: "",
            searchEmail: "",

            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false
        }
        this.handleAddClient = this.handleAddClient.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleShare = this.handleShare.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleSaveShare = this.handleSaveShare.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
    }

    render() {
        const {
            open,
            openShare,
            dialogTitle,
            dialogData,
            dialogState,
            tabIndex,
            stateRight,
            iClients,
            cClients,
            searchName,
            searchEmail,
            page_index,
            page_size,
            total_items,
            showToast,
            toastMsg,
            toastState,
            showAlert,
        } = this.state;

        const corpColumns = isRole(ROLES.admin) ? [
            {id: 'cid', label: 'Client ID', width: '20%'},
            {id: 'name', label: 'Name', width: '20%'},
            {id: 'city', label: 'city', width: '10%'},
            {id: 'state', label: 'state', width: '10%'},
            {id: 'address', label: 'Address', width: '20%'},
            {id: 'others', label: 'Others', width: '20%'},
        ] : [
            {id: 'name', label: 'Name', width: '30%'},
            {id: 'address', label: 'Address', width: '20%'},
            {id: 'city', label: 'city', width: '15%'},
            {id: 'state', label: 'state', width: '15%'},
            {id: 'others', label: 'Others', width: '20%'},
        ];

        // const delBtn = (row) => {
        //     if (roleName === ADMIN) {
        //         return <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
        //     }
        // };

        const showTabPanel = () => {
            if (tabIndex === 0) {
                return <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                {isRole(ROLES.admin) && <TableCell>Client ID</TableCell>}
                                <TableCell>First Name</TableCell>
                                <TableCell>Last Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Wechat</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {iClients.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    {isRole(ROLES.admin) && <TableCell component="th" scope="row">
                                        {row.individual.id}
                                    </TableCell>}
                                    <TableCell>{row.individual.first_name}</TableCell>
                                    <TableCell>{row.individual.last_name}</TableCell>
                                    <TableCell>{row.individual.email ? row.individual.email : "--"}</TableCell>
                                    <TableCell>{row.individual.phone ? row.individual.phone : "--"}</TableCell>
                                    <TableCell>{row.individual.wechat ? row.individual.wechat : "--"}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary"
                                                    onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary"
                                                    onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            {/*<Button variant="outlined" color="primary" onClick={e => this.handleShare(e, row)}>Share List</Button>*/}
                                            {/* {delBtn(row)} */}
                                            <DeleteForeverIcon className="del"
                                                               onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {iClients.length === 0 && (
                                <TableRow style={{height: 300}}>
                                    <TableCell colSpan={12}/>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={iClients.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: {'arialabel': 'Rows per page'},
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            } else if (tabIndex === 1) {
                return <Paper className="tableWapper">
                    <Table stickyHeader className="table fixed-table">
                        <TableHead>
                            <TableRow role="checkbox">
                                {corpColumns.map((column) => (
                                    <TableCell key={column.id} style={{width: column.width}}>
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cClients.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    {isRole(ROLES.admin) && <TableCell component="th" scope="row">
                                        {row.corporation.id}
                                    </TableCell>}
                                    <TableCell>{row.corporation.name}</TableCell>
                                    <TableCell>{row.corporation.address && row.corporation.address.address ? row.corporation.address.address : "--"}</TableCell>
                                    <TableCell>{row.corporation.address && row.corporation.address.city ? row.corporation.address.city : "--"}</TableCell>
                                    <TableCell>{row.corporation.address && row.corporation.address.state ? row.corporation.address.state : "--"}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary"
                                                    onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary"
                                                    onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            {/*<Button variant="outlined" color="primary" onClick={e => this.handleShare(e, row)}>Share List</Button>*/}
                                            {/* {delBtn(row)} */}
                                            <DeleteForeverIcon className="del"
                                                               onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {cClients.length === 0 && (
                                <TableRow style={{height: 300}}>
                                    <TableCell colSpan={12}/>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={cClients.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: {'arialabel': 'Rows per page'},
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Clients" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleAddClient}>ADD
                            CLIENT</Button>
                    </div>
                </div>
                <div>
                    <Tabs
                        value={tabIndex}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleChange}
                        aria-label="disabled tabs example"
                        TabIndicatorProps={{style: {display: "none"}}}
                    >
                        <Tab className={tabIndex === 0 ? "tabSelect" : "tab"} label="Individual"/>
                        <Tab className={tabIndex === 1 ? "tabSelect" : "tab"} label="Corporation"/>
                    </Tabs>
                </div>
                <div className="tableTool h">
                    <Button className="bgW btn" variant="contained" onClick={e => this.handleDrawer(e, true)}> Show
                        Filters </Button>
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search/>
                        </div>
                        <InputBase
                            placeholder="Search client by name"
                            className="bgW"
                            inputProps={{'aria-label': 'Search'}}
                            value={searchName}
                            onChange={e => this.handleSearch(e, 'name')}
                        />
                    </div>
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search/>
                        </div>
                        <InputBase
                            placeholder="Search client by email"
                            className="bgW"
                            inputProps={{'aria-label': 'Search'}}
                            value={searchEmail}
                            onChange={e => this.handleSearch(e, 'email')}
                        />
                    </div>
                </div>
                {showTabPanel()}
                <Dialog maxWidth={false} open={open}>
                    <Client
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                        ICType={tabIndex}
                    ></Client>
                </Dialog>
                <Dialog maxWidth={false} open={openShare}>
                    <ShareList
                        handleSaveShare={this.handleSaveShare}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                    />
                </Dialog>
                <Drawer anchor="right" open={stateRight} onClose={e => this.handleDrawer(e, false)}>
                    <div
                        role="presentation"
                    >
                        <SideList
                            handleApply={this.handleApply}
                        ></SideList>
                    </div>
                </Drawer>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this client?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }

    componentDidMount() {
        this.getClients();
    }

    getClients() {
        const {tabIndex} = this.state;
        if (tabIndex === 0) {
            this.getIClients();
        } else if (tabIndex === 1) {
            this.getCClients();
        }
    }

    getCClients() {
        const {page_index, page_size, searchName, searchEmail} = this.state;
        let params = {
            target: "corp",
            name: searchName ? searchName : null,
            email: searchEmail ? searchEmail : null,
            state: AUDITED,
            page_index,
            page_size
        }
        this.getCClientList(params);
    }

    getIClients() {
        const {page_index, page_size, searchName, searchEmail} = this.state;
        let params = {
            name: searchName ? searchName : null,
            email: searchEmail ? searchEmail : null,
            state: AUDITED,
            page_index,
            page_size
        }
        this.getIClientList(params);
    }

    //tab选项卡
    handleChange(e, newValue) {
        let tabIndex = newValue;
        this.setState({
            tabIndex,
            searchName: "",
            searchEmail: "",
            page_index: 1,
            page_size: defaultPageSize
        }, () => {
            this.getClients();
        })
    }

    handleAddClient() {
        this.setState(() => ({
            dialogData: null
        }))
        this.openDialog("ADD CLIENT", CLIENT, ADD);
    }

    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("VIEW CLIENT", CLIENT, VIEW);
    }

    handleEdit(e, obj) {
        const client_id = obj.id;
        this.setState(() => ({
            dialogData: obj,
            client_id
        }))
        this.openDialog("EDIT CLIENT", CLIENT, EDIT);
    }

    handleShare(e, obj) {
        const client_id = obj.id;
        this.setState(() => ({
            dialogData: obj,
            client_id
        }))
        this.openShareDialog("Share Client to Them");
    }


    handleDel(e, obj) {
        this.setState(() => ({
            dialogData: obj,
            showAlert: true
        }));
    }

    handleCloseDialog() {
        this.closeDialog();
    }

    handleCancel() {
        this.closeDialog();
    }

    handleSaveShare() {
        this.closeDialog();
        this.getClients();
    }

    handleCreate(radioValue, obj) {
        const {dialogState, client_id} = this.state;
        console.log(dialogState, radioValue, radioValue)
        if (radioValue === INDIVIDUAL) {//个人
            if (dialogState === ADD) {
                this.addIndividual(obj)
            } else if (dialogState === EDIT) {
                this.editIndividual(client_id, obj)
            }
        } else if (radioValue === CORPORATION) {//公司
            if (dialogState === ADD) {
                this.addCorporation(obj)
            } else if (dialogState === EDIT) {
                this.editCorporation(client_id, obj)
            }
        }
    }

    handleSearch(e, name) {
        const value = e.target.value;
        if (name === "name") {
            this.setState({
                searchName: value,
                page_index: 1
            }, () => {
                this.getClients();
            })
        } else if (name === "email") {
            this.setState({
                searchEmail: value,
                page_index: 1
            }, () => {
                this.getClients();
            })
        }
    }

    handleDrawer(e, open) {
        this.setState(() => ({
            stateRight: open
        }));
    };

    handleApply(obj) {
        console.log(obj)
        this.setState({
            page_index: 1,
            stateRight: false,
        }, () => {
            this.getClients();
        })
    }

    handleChangePage(e, newPage) {
        console.log(newPage + 1)
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getClients();
        })
    }

    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getClients();
        });
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    handleAlertYes() {
        const {tabIndex, dialogData} = this.state;
        if (tabIndex === 0) {
            this.delIndividual(dialogData.id);
        } else if (tabIndex === 1) {
            this.delCorporation(dialogData.id);
        }
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }

    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }

    closeDialog() {
        this.setState(() => ({
            open: false,
            openShare: false,
            dialogData: null,
        }));
    }

    openDialog(title, type, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
            dialogType: type,
        }));
    }

    openShareDialog(title) {
        this.setState(() => ({
            openShare: true,
            dialogTitle: title,
        }));
    }

    getUserDepartment(teamData) {
        if (teamData) {
            if (teamData !== null && teamData.length > 0) {
                let deptObj = teamData[0].dept;
                let deptName = deptObj.name;
                return deptName
            }
        }
        return "";
    }

    attorneyInfo(handlerArr, type) {
        if (handlerArr) {
            let attorneyObj = {};
            for (const obj of handlerArr) {
                if (obj.is_origin_attorney) {
                    attorneyObj = obj;
                }
            }
            if (attorneyObj) {
                if (type === "name") {
                    const userObj = attorneyObj.user;
                    console.log(attorneyObj)
                    return userObj ? userObj.first_name + " " + userObj.last_name : "";
                } else if (type === "team") {
                    const teamObj = attorneyObj.team;
                    return teamObj ? teamObj.name : "";
                }
            }
        }
        return "--";
    }

    filterIIncludeArr(arr, value, name) {
        let newArr = [];
        for (let obj of arr) {
            if (name === "name") {
                console.log(obj)
                if (obj.individual.first_name.includes(value) || obj.individual.last_name.includes(value)) {
                    newArr.push(obj);
                }
            } else if (name === "email") {
                if (obj.individual.email.includes(value)) {
                    newArr.push(obj);
                }
            }
        }
        return newArr;
    }

    filterCIncludeArr(arr, value, name) {
        let newArr = [];
        for (let obj of arr) {
            if (name === "name") {
                if (obj.corporation.name.includes(value)) {
                    newArr.push(obj);
                }
            }
        }
        return newArr;
    }

    editAttorney(client_id, handler, callback) {
        const {dialogData} = this.state;
        if (dialogData.editable === false) {
            callback();
            return;
        }
        const addHandler = handler;
        const delHandler = this.extAttorney(dialogData.handler);
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = delHandler.handler_id;
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = delHandler.handler_team_id;
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                callback();
            } else {
                this.delMembers(client_id, delHandler, () => {
                    this.addMembers(client_id, addHandler, () => {
                        callback();
                    });
                });
            }
        }
    }

    extAttorney(handlers) {
        let handlerObj = {};
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                handlerObj.handler_id = obj.user.id;
                handlerObj.handler_team_id = obj.team.id;
                handlerObj.is_origin_attorney = obj.is_origin_attorney;
                return handlerObj;
            }
        }
        return null;
    }

    //---------------request---------------
    getIClientList(params) {
        instance.get(BASE_URL + roleStr() + '/clients', {params}).then((res) => {
            const iClients = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(iClients);
            this.setState(() => ({
                iClients,
                iClientsCopy: iClients,
                page_size,
                total_items
            }))
        })
    }

    getCClientList(params) {
        instance.get(BASE_URL + roleStr() + '/clients', {params}).then((res) => {
            const cClients = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(cClients);
            this.setState(() => ({
                cClients,
                cClientsCopy: cClients,
                page_size,
                total_items
            }))
        })
    }

    addIndividual(obj) {
        const params = {
            // related_parties: obj.related_parties,
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            note: obj.note,
            handlers: obj.handlers,
        }
        instance.post(BASE_URL + roleStr() + '/clients/individual', params).then((res) => {
            console.log("创建", res)
            const id = res.data.data.id;
            this.iApproval(id)
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    addCorporation(obj) {
        const params = {
            // referral_source: obj.referral_source,
            // related_parties: obj.related_parties,
            // members: obj.members,
            name: obj.name,
            address: obj.address,
            note: obj.note,
            contacts: obj.contacts,
            handlers: obj.handlers,
        }
        instance.post(BASE_URL + roleStr() + '/clients/corporation', params).then((res) => {
            console.log(res)
            const id = res.data.data.id;
            this.cApproval(id)
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    editIndividual(client_id, obj) {
        const params = {
            // related_parties: obj.related_parties,
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            note: obj.note,
            // handlers: obj.handlers,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            this.showToast("Successfully modified", "success");
            this.closeDialog();
            this.getIClients();
            this.setState(() => ({
                tabIndex: 0
            }));
            // this.editAttorney(client_id, obj.handlers, () => {
            //     this.showToast("Successfully modified", "success");
            //     this.closeDialog();
            //     this.getIClients();
            //     this.setState(() => ({
            //         tabIndex: 0
            //     }));
            // });
        })
    }

    editCorporation(client_id, obj) {
        const params = {
            // referral_source: obj.referral_source,
            // related_parties: obj.related_parties,
            // members: obj.members,
            name: obj.name,
            address: obj.address,
            note: obj.note,
            contacts: obj.contacts,
            // handlers: obj.handlers,
        };
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/corporation', params).then((res) => {
            console.log(res);
            this.showToast("Successfully modified", "success");
            this.closeDialog();
            this.getCClients();
            this.setState(() => ({
                tabIndex: 1
            }));
            // this.editAttorney(client_id, obj.handlers, () => {
            //     this.showToast("Successfully modified", "success");
            //     this.closeDialog();
            //     this.getCClients();
            //     this.setState(() => ({
            //         tabIndex: 1
            //     }));
            // });
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    delIndividual(client_id) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.delete(BASE_URL + role + '/clients/' + client_id).then((res) => {
            console.log(res)
            this.showToast("Successfully deleted", "success");
            this.getIClients();
        }).catch((err) => {
            const errorCode = err.response.data.error;
            if (errorCode === 3000) {
                this.showToast("Failed to delete, the client has been used", "error");
            }
        })
    }

    delCorporation(client_id) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.delete(BASE_URL + role + '/clients/' + client_id).then((res) => {
            console.log(res)
            this.showToast("Successfully deleted", "success");
            this.getCClients();
        }).catch((err) => {
            const errorCode = err.response.data.error;
            if (errorCode === 3000) {
                this.showToast("Failed to delete, the client has been used", "error");
            }
        })
    }

    iApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        console.log("params", params)
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            console.log("审核", res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    cApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/corporation', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    addMembers(client_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.post(BASE_URL + roleStr() + '/clients/' + client_id + '/handlers', params).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    delMembers(client_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.delete(BASE_URL + roleStr() + '/clients/' + client_id + '/handlers', {data: params}).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(Clientlist);